import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass, resolveComponent as _resolveComponent, createVNode as _createVNode, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "notifications full-width" }
const _hoisted_2 = { class: "flex flex-justify-between flex-align-end mb-2" }
const _hoisted_3 = { class: "max-width-text" }
const _hoisted_4 = ["disabled"]
const _hoisted_5 = { class: "notifications__container" }
const _hoisted_6 = { class: "notifications__container__menu" }
const _hoisted_7 = ["onClick"]
const _hoisted_8 = {
  key: 0,
  class: "notifications__sheet-overlay"
}
const _hoisted_9 = { class: "notifications__sheet" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_notification_detail = _resolveComponent("notification-detail")!
  const _component_crud_email = _resolveComponent("crud-email")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("h1", null, _toDisplayString(_ctx.$t('MY_ENVIRONMENT.NOTIFICATIONS')), 1),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("p", _hoisted_3, _toDisplayString(_ctx.$t('MY_ENVIRONMENT.NOTIFICATION.NOTIFICATION_TEXT')), 1),
      (_ctx.hasPermission(_ctx.permissions.NotificationChange))
        ? (_openBlock(), _createElementBlock("button", {
            key: 0,
            class: "notifications__add-button ml-2",
            color: "accent",
            onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.openCreateEmailSheet && _ctx.openCreateEmailSheet(...args))),
            disabled: (_ctx.impersonated && !_ctx.impersonatedWithOriginalRights),
            type: "button"
          }, [
            _cache[3] || (_cache[3] = _createElementVNode("i", { class: "icons8-mail-account" }, null, -1)),
            _createTextVNode(_toDisplayString(_ctx.$t('MY_ENVIRONMENT.NOTIFICATION.ADD_EMAIL')), 1)
          ], 8, _hoisted_4))
        : _createCommentVNode("", true)
    ]),
    _createElementVNode("div", _hoisted_5, [
      _createElementVNode("div", _hoisted_6, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.menuItems, (menuItem) => {
          return (_openBlock(), _createElementBlock("div", {
            class: _normalizeClass(["notifications__container__menu__item flex flex-align-center pa-2", {"active" : _ctx.notificationType === menuItem.notificationType}]),
            onClick: ($event: any) => (_ctx.notificationType = menuItem.notificationType)
          }, [
            _createElementVNode("i", {
              class: _normalizeClass(["mr-05", menuItem.icon])
            }, null, 2),
            _createTextVNode(_toDisplayString(_ctx.$t(menuItem.titleKey)), 1)
          ], 10, _hoisted_7))
        }), 256))
      ]),
      _createVNode(_component_notification_detail, {
        class: "flex-grow-1 pa-2",
        "notification-type": _ctx.notificationType,
        onEditEmail: _cache[1] || (_cache[1] = ($event: any) => (_ctx.showCrudEmailSheet($event.notification, $event.action)))
      }, null, 8, ["notification-type"])
    ]),
    (_ctx.showCrudEmail)
      ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
          _createElementVNode("div", _hoisted_9, [
            (_ctx.showCrudEmail)
              ? (_openBlock(), _createBlock(_component_crud_email, {
                  key: 0,
                  action: _ctx.action,
                  "notification-request": _ctx.notificationRequest,
                  onHide: _cache[2] || (_cache[2] = ($event: any) => (_ctx.closeCrudEmailSheet()))
                }, null, 8, ["action", "notification-request"]))
              : _createCommentVNode("", true)
          ])
        ]))
      : _createCommentVNode("", true)
  ]))
}